import React from 'react';
import { Input, Form } from 'antd';

// https://ant.design/components/form/#components-form-demo-basic
const FormHiddenField = ({ name, rules, value, ...rest }) => {
  return (
    <Form.Item name={name} rules={rules} initialValue={value} noStyle hidden>
      <Input type="hidden" {...rest} />
    </Form.Item>
  );
};

export default FormHiddenField;
